import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  async getLLMApiKeys({ commit, state }, query) {
    const headers = getTokenHeader();
    if (headers && state.selectedPrincipal?.id) {
      try {
        const response = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/admin`,
          {
            params: {
              ...query,
              principal_id: state.selectedPrincipal.id
            },
            headers
          }
        );
        commit("SET_LLM_API_KEYS", response?.data);
      } catch (e) {
        await this.dispatch("createError", e);
      }
    }
  },
  async getLLMConfig({ commit, state }, query = {}) {
    const headers = getTokenHeader();
    if (headers && state.selectedPrincipal?.id) {
      try {
        const response = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/config`,
          {
            params: {
              ...query,
              principal_id: state.selectedPrincipal.id
            },
            headers
          }
        );
        commit("SET_LLM_CONFIG", response?.data ?? {});
      } catch (e) {
        await this.dispatch("createError", e);
      }
    }
  }
};
